export default {"src":"/_next/static/media/deleteBlock.826adb5b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};